// https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript

const byteSizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
const bitSizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];

export function formatBytes(bytes: number, decimals = 2, binaryUnits = false) {
  if (bytes === 0) {
    return '0 Bytes';
  }
  const unitMultiple = binaryUnits ? 1024 : 1000;
  const unitNames = binaryUnits // 1000 bytes in 1 Kilobyte (KB) or 1024 bytes for the binary version (KiB)
    ? bitSizes
    : byteSizes;
  const unitChanges = Math.floor(Math.log(bytes) / Math.log(unitMultiple));
  return `${parseFloat((bytes / unitMultiple ** unitChanges).toFixed(decimals || 0))} ${
    unitNames[unitChanges]
  }`;
}
